import { BRANCH, HOST } from './env'

export const BASE_URL = HOST

export const PATH = {
  home: '/',
  events: '/events/',
  demoUrl: '/demo/',
  pricingUrl: '/pricing/',
  accountTakeover: '/use-cases/account-takeover/',
  ecommerce: '/e-commerce/',
  gaming: '/igaming/',
  travel: '/travel/',
  cryptocurrency: '/cryptocurrency/',
  paymentFraud: '/use-cases/payment-fraud/',
  blog: '/blog/',
  paywall: '/use-cases/paywall/',
  caseStudies: '/case-studies/',
  botDirectory: '/bot-directory/',
  contactSales: '/contact-sales/',
  whyFpjs: '/products/fingerprint-pro/',
  identification: '/products/identification/',
  accountSharing: '/use-cases/account-sharing-prevention/',
  botD: '/products/bot-detection/',
  bnpl: '/buy-now-pay-later/',
  careers: '/careers/',
  aiinfopage: '/blog/ai-info-page/',
  support: '/support/',
  security: '/security/',
  useCases: '/use-cases/',
  ai: '/ai/',
  tutorials: '/blog/tag/tutorials/',
  guides: '/blog/tag/guides/',
  resources: '/resources/',
  templates: '/templates/',
  faq: '/resources/frequently-asked-questions-faqs/',
  press: '/resources/press/',
  vsThreatMetrix: '/resources/comparisons/compare-fingerprint-vs-threatmetrix/',
  vsTruValidate: '/resources/comparisons/compare-fingerprint-vs-truvalidate/',
  integrations: '/integrations/',
  sdks: '/sdk-libraries/',
  github: '/github/',
  aboutUs: '/about-us',
  smartSignals: '/products/smart-signals/',
  partners: '/partners/',
  finserv: '/fintech',
  banking: '/banking',
  smsFraud: '/use-cases/sms-fraud/',
  personalization: '/blog/providing-personalization-to-anonymous-users/',
  couponPromo: '/blog/prevent-coupon-promo-abuse-increase-sales/',
  credentialStuffing: '/blog/credential-stuffing-prevention-checklist/',
  newAccountFraudPrevention: '/use-cases/new-account-fraud-prevention/',
  mobileAppDetection: '/use-cases/mobile-app-detection/',
  returningUserExperience: '/use-cases/returning-user-experience/',
  webBotAuthTest: '/web-bot-auth/test/',
  automationDetection: '/products/ai-agent-detection/',
} as const

export const USE_CASE_PATH = {
  personalization: '/blog/providing-personalization-to-anonymous-users/',
  accountSharing: '/blog/account-sharing-prevention/',
  paymentFraud: '/blog/implementation-guide-payment-fraud-prevention-device-intelligence/',
  credentialStuffing: '/blog/credential-stuffing-prevention-checklist/',
} as const

export const URL = {
  githubRepoUrl: 'https://github.com/fingerprintjs/fingerprintjs/',
  githubApiUrl: 'https://api.github.com/repos/fingerprintjs',
  githubCommunityRepoUrl: 'https://github.com/fingerprintjs/home',
  botDRepoUrl: 'https://github.com/fingerprintjs/BotD',
  botDIntegrationsRepoUrl: 'https://github.com/fingerprintjs/botd-integrations',
  dashboardLoginUrl: 'https://dashboard.fingerprint.com/login',
  careersUrl: 'https://boards.greenhouse.io/fingerprintjs/',
  careersConsoleLogUrl: 'https://fingerprint.com/careers/',
  linkedinUrl: 'https://www.linkedin.com/company/fingerprintjs/',
  twitterUrl: 'https://twitter.com/FingerprintJs/',
  signupUrl: 'https://dashboard.fingerprint.com/signup',
  statusUrl: 'https://status.fingerprint.com',
  supportMail: 'support@fingerprint.com',
  salesMail: 'sales@fingerprint.com',
  worKMail: 'work@fingerprint.com',
  pressMail: 'press@fingerprint.com',
  securityMail: 'security@fingerprint.com',
  discordServerURL: 'https://discord.gg/ad6R2ttHVX',
  docsUrl: 'https://docs.fingerprint.com',
  promotionalVideo: 'https://www.youtube.com/embed/UEYBysyPTBs',
  demoVideo: 'https://www.youtube.com/embed/hVktdWfyBuU',
  g2ReviewUrl: 'https://www.g2.com/products/fingerprintjs-fingerprint/reviews',
  hubUrl: 'https://demo.fingerprint.com/',
  planUrl: 'https://dashboard.fingerprint.com/plan',
  templatesUrl: 'https://dashboard.fingerprint.com/templates/',
} as const

export const DEMO_URL = {
  smartSignals: `${URL.hubUrl}playground/`,
  couponFraud: `${URL.hubUrl}coupon-fraud/`,
  credentialStuffing: `${URL.hubUrl}credential-stuffing/`,
  loanRisk: `${URL.hubUrl}loan-risk/`,
  paymentFraud: `${URL.hubUrl}payment-fraud`,
  paywall: `${URL.hubUrl}paywall/`,
  personalization: `${URL.hubUrl}personalization/`,
  webScraping: `${URL.hubUrl}web-scraping/`,
} as const

export const MAILTO = { mailToUrl: `mailto:${URL.supportMail}` } as const
export const MAILTO_WORK = { mailToUrl: `mailto:${URL.worKMail}` } as const
export const MAILTO_SALES = { mailToUrl: `mailto:${URL.salesMail}` } as const
export const MAILTO_SECURITY = { mailToUrl: `mailto:${URL.securityMail}` } as const

// Links to README pages should not have trailing slashes to prevent forwarding.
export const DOC_URL = {
  documentationUrl: URL.docsUrl,
  proVsOpenUrl: 'https://fingerprint.com/github',
  browserFingerprintUrl: `${URL.docsUrl}/docs/introduction`,
  incognitoUrl: `${URL.docsUrl}/docs/smart-signals-reference`,
  serverApiUrl: `${URL.docsUrl}/docs/server-api`,
  legalUrl: `${URL.docsUrl}/docs/dpa-gdpr`,
  termOfUseUrl: `${URL.docsUrl}/docs/terms-of-service`,
  privacyPolicyUrl: `${URL.docsUrl}/docs/privacy-policy`,
  browserSupportUrl: `${URL.docsUrl}/docs/browser-and-device-support`,
  webhooksUrl: `${URL.docsUrl}/docs/webhooks`,
  botDUrl: 'https://github.com/fingerprintjs/BotD#botd',
  zeroTrustUrl: `${URL.docsUrl}/docs/zero-trust-mode`,
  migrateUrl: `${URL.docsUrl}/docs/migrating-from-fingerprintjs-to-fingerprint-pro#migrating-from-fingerprintjs-v3-open-source-to-fingerprint-identification`,
  botDetectionGuide: `${URL.docsUrl}/docs/bot-detection/overview`,
  jsAgent: `${URL.docsUrl}/reference/js-agent`,
  quickStartCustomSubdomain: `${URL.docsUrl}/docs/custom-subdomain-setup`,
  quickStartWebhooks: `${URL.docsUrl}/docs/webhooks`,
  quickStartServerApi: `${URL.docsUrl}/docs/server-api`,
  pricing: `${URL.docsUrl}/docs/billing`,
  serverApi: `${URL.docsUrl}/reference/server-api`,
  smartSignalsMobile: `${URL.docsUrl}/docs/smart-signals-reference#smart-signals-for-mobile-devices`,
  gettingStartedMobile: `${URL.docsUrl}/docs/mobile-sdks`,
  smartSignalsIntroduction: `${URL.docsUrl}/docs/smart-signals-introduction`,
  browserSmartSignalsFragment: `${URL.docsUrl}/docs/smart-signals-introduction#browser-smart-signals`,
  mcpServer: `${URL.docsUrl}/docs/mcp-server`,
  useCaseTutorials: `${URL.docsUrl}/docs/use-case-tutorials-overview`,
  quickStartGuide: `${URL.docsUrl}/docs/quick-start-guide`,
} as const

export const INTEGRATIONS_URL = {
  android: `${URL.docsUrl}/docs/native-android-integration`,
  angular: `${URL.docsUrl}/docs/angular`,
  flutter: `${URL.docsUrl}/docs/flutter`,
  go: `${URL.docsUrl}/reference/go-server-sdk`,
  ios: `${URL.docsUrl}/docs/ios`,
  js: `${URL.docsUrl}/reference/js-agent`,
  ts: `${URL.docsUrl}/reference/js-agent#typescript-support`,
  next: `${URL.docsUrl}/docs/fingerprintjs-pro-nextjs`,
  node: `${URL.docsUrl}/reference/node-server-sdk`,
  openApi: `${URL.docsUrl}/reference/openapi-schema`,
  preact: `${URL.docsUrl}/docs/preact`,
  python: `${URL.docsUrl}/reference/python-server-sdk`,
  react: `${URL.docsUrl}/docs/react`,
  reactNative: `${URL.docsUrl}/docs/fingerprintjs-pro-react-native`,
  svelte: `${URL.docsUrl}/docs/svelte`,
  vue: `${URL.docsUrl}/docs/vuejs`,
  gtm: `${URL.docsUrl}/docs/fingerprintjs-pro-google-tag-manager`,
  cloudflare: `${URL.docsUrl}/docs/cloudflare-integration`,
  chrome: `${URL.docsUrl}/docs/fingerprintjs-pro-and-chrome-extension`,
  java: `${URL.docsUrl}/reference/java-server-sdk`,
  kotlin: `${URL.docsUrl}/docs/android-sdk`,
  swift: `${URL.docsUrl}/docs/ios`,
} as const

export const QUICK_START_URL = {
  android: `${URL.docsUrl}/docs/android-quickstart`,
  angular: `${URL.docsUrl}/docs/angular-quickstart`,
  flutter: `${URL.docsUrl}/docs/flutter-quickstart`,
  go: `${URL.docsUrl}/docs/go-server-quickstart`,
  ios: `${URL.docsUrl}/docs/ios-quickstart`,
  js: `${URL.docsUrl}/docs/javascript-quickstart`,
  ts: `${URL.docsUrl}/docs/javascript-quickstart`,
  next: `${URL.docsUrl}/docs/nextjs-quickstart`,
  node: `${URL.docsUrl}/docs/node-server-quickstart`,
  openApi: `${URL.docsUrl}/docs/javascript-quickstart`,
  preact: `${URL.docsUrl}/docs/preact-quickstart`,
  python: `${URL.docsUrl}/docs/python-server-quickstart`,
  react: `${URL.docsUrl}/docs/react-quickstart`,
  reactNative: `${URL.docsUrl}/docs/react-native-quickstart`,
  svelte: `${URL.docsUrl}/docs/svelte-quickstart`,
  vue: `${URL.docsUrl}/docs/vue-quickstart`,
  gtm: `${URL.docsUrl}/docs/javascript-quickstart`,
  cloudflare: `${URL.docsUrl}/docs/javascript-quickstart`,
  chrome: `${URL.docsUrl}/docs/javascript-quickstart`,
  java: `${URL.docsUrl}/docs/java-server-quickstart`,
  kotlin: `${URL.docsUrl}/docs/android-quickstart`,
  swift: `${URL.docsUrl}/docs/ios-quickstart`,
} as const

export const defaultDataLayer = [{ branch: BRANCH }]

// When changing this, some markdown files need to be changed as well.
export const DEFAULT_TRIAL_DAYS = 14

export const THOUSAND_IDENTIFICATIONS_PRICE = 4

export const SUSPECT_SCORE_DOCS_URL = `${DOC_URL.documentationUrl}/docs/suspect-score`
export const SUSPECT_SCORE_MAX_VALUE = 10
